import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
  PassChanged: false,
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
};

export const updatePassword = createAsyncThunk(
  'api/auth/setPassword',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.put('/api/auth/setPassword', udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let data = response.data;
      // console.log(data)
      if (response.status === 200) {
        return data;
       // window.location.reload();
      }
      else if (response.status === 201) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);




export const resetPasswordSlice = createSlice({
  name: 'resetPassword',
  initialState,
  reducers: {
    clearStateResetPassword: (state, { payload }) => {
      //state.user = {};
      // state.isFetching = false;
      // state.isSuccess = false;
      state.PassChanged = false;
      state.isError = false;
      state.errorMessage = '';
    },
  },

  extraReducers: {
    [updatePassword.fulfilled]: (state, { payload }) => {

      //   state.viewProcess = payload.data;
      //   state.isFetching = false;
      //   state.isSuccess = true;


      if (payload.success == false) state.isError = true;
      else state.isError = false;
      if (payload.success) state.PassChanged = true;
      if (payload.message) state.errorMessage = payload.message;
      else state.errorMessage = '';


      return state;
    },
    [updatePassword.pending]: (state) => {
      state.isFetching = true;
    },
    [updatePassword.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    }
  },
});

export const { clearStateResetPassword } = resetPasswordSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateResetPassword());
  }
}

export const viewProcessSelector = (state) => state.resetPassword;

export default resetPasswordSlice.reducer;
